<template>
<m-dialog
    v-if="visible"
    :id="dialog.name || null"
    ref="dialog"
    :options="dialog"
    @click="onClick"
    @close="RESOLVE_DIALOG">
    <component
        :is="dialog.slot"
        v-if="dialog.slot"
        :dialog.sync="dialog"
        @content-action="onClick"
        @close="onClose" />
    <template
        v-if="dialog.slot_bottom"
        #bottom>
        <component
            :is="dialog.slot_bottom"
            :dialog="dialog" />
    </template>
</m-dialog>
</template>

<script>
import { mapMutations } from "vuex";
import mDialog from "@/components/mdc/Dialog.vue";

export default {
    components: { mDialog },
    computed: {
        dialog: {
            get() {
                return this.$store.getters.dialog;
            },
            set(value) {
                this.UPDATE_DIALOG_OPTION(value);
            }
        },
        visible() {
            const { title, content, slot } = this.dialog;
            return title || content || slot;
        }
    },
    watch: {
        visible(value) {
            if (!value) return;
            const scr =
                window.innerWidth - document.documentElement.clientWidth;
            const id = "mdc-dialog-scroll-lock__stay-still";
            let $s = document.querySelector(`#${id}`);
            if (!$s) {
                $s = document.createElement("style");
                $s.id = id;
                $s.type = "text/css";
            }
            $s.innerHTML = `
            .mdc-dialog-scroll-lock #app,
            .mdc-dialog-scroll-lock .mdc-top-app-bar__section--align-end {margin-right:${scr}px;}`;
            document.head.appendChild($s);
        }
    },
    methods: {
        ...mapMutations(["RESOLVE_DIALOG", "UPDATE_DIALOG_OPTION"]),
        onClick(action, params) {
            const handler = this.dialog[action];
            if (!handler || typeof handler !== "function") return;
            handler(this.$refs.dialog.instance, this.dialog, params);
        },
        onClose() {
            this.$refs.dialog.instance.close();
        }
    }
};
</script>
